import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Checkbox } from '@repo/design-system/components/ui/checkbox';
import { Fieldset } from '@repo/design-system/components/ui/fieldset';
import { Form } from '@repo/design-system/components/ui/form';
import { Select, SelectItem } from '@repo/design-system/components/ui/select';
import { TextArea } from '@repo/design-system/components/ui/text-area';
import { TextInput } from '@repo/design-system/components/ui/text-input';
import { toast } from '@repo/design-system/components/ui/toaster';
import { useT } from '@repo/i18n/components/i18n.client';
import { useCreateMapSubcategoryMutation } from '@repo/store/maps/api/mapsApi';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectMapCategories, selectTitleSlug } from '@repo/store/maps/slices/mapData';
import { useCallback, useMemo, useState } from 'react';
import { MapIconSelector } from './map-icon-selector';
export interface AddSubcategoryFormProps {
  forcedCategoryId?: string;
}
interface SubcategoryFormState {
  subcategoryName: string;
  selectedIcon: string;
  selectedCategory: string;
  description: string;
  excludeFromChecklists: boolean;
}
const initialFormState: SubcategoryFormState = {
  subcategoryName: '',
  selectedIcon: '',
  selectedCategory: '',
  description: '',
  excludeFromChecklists: false
};
export const AddSubcategoryForm = t0 => {
  const $ = _c(76);
  const {
    forcedCategoryId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  const mapCategories = useAppSelector(selectMapCategories);
  const externalMapId = useAppSelector(selectExternalMapId);
  const titleSlug = useAppSelector(selectTitleSlug);
  const [createSubcategory, t2] = useCreateMapSubcategoryMutation();
  const {
    isLoading
  } = t2;
  const t3 = forcedCategoryId || "";
  let t4;
  if ($[1] !== t3) {
    t4 = {
      ...initialFormState,
      selectedCategory: t3
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [formState, setFormState] = useState(t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = updates => {
      setFormState(prev => ({
        ...prev,
        ...updates
      }));
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const updateFormState = t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setFormState(initialFormState);
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleCancel = t6;
  let t7;
  if ($[5] !== createSubcategory || $[6] !== externalMapId || $[7] !== formState || $[8] !== t) {
    t7 = async () => {
      const {
        subcategoryName,
        selectedIcon,
        selectedCategory,
        description,
        excludeFromChecklists
      } = formState;
      if (!subcategoryName.trim() || !selectedIcon || !selectedCategory || !externalMapId) {
        return;
      }
      try {
        await createSubcategory({
          subcategory: {
            title: subcategoryName,
            icon: selectedIcon,
            categoryExternalId: selectedCategory,
            description,
            excludeFromChecklists
          },
          mapExternalId: externalMapId
        }).unwrap();
        setFormState(initialFormState);
        toast({
          title: t(_temp),
          description: t(_temp2),
          variant: "success"
        });
      } catch {
        toast({
          title: t(_temp3),
          description: t(_temp4),
          variant: "error"
        });
      }
    };
    $[5] = createSubcategory;
    $[6] = externalMapId;
    $[7] = formState;
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleSave = t7;
  let t8;
  bb0: {
    if (!mapCategories) {
      let t9;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [];
        $[10] = t9;
      } else {
        t9 = $[10];
      }
      t8 = t9;
      break bb0;
    }
    let t9;
    if ($[11] !== mapCategories) {
      t9 = mapCategories.map(_temp5);
      $[11] = mapCategories;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    t8 = t9;
  }
  const categoryOptions = t8;
  let t9;
  if ($[13] !== formState.selectedCategory || $[14] !== formState.selectedIcon || $[15] !== formState.subcategoryName) {
    t9 = formState.subcategoryName.trim() && formState.selectedIcon && formState.selectedCategory;
    $[13] = formState.selectedCategory;
    $[14] = formState.selectedIcon;
    $[15] = formState.subcategoryName;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const isFormValid = t9;
  let t10;
  if ($[17] !== handleSave) {
    t10 = e => {
      e.preventDefault();
      handleSave();
    };
    $[17] = handleSave;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t(_temp6);
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = t(_temp7);
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = formState.subcategoryName;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = e_0 => updateFormState({
      subcategoryName: e_0.target.value
    });
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = t(_temp8);
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== formState.subcategoryName || $[27] !== t12 || $[28] !== t15) {
    t16 = <TextInput fullWidth={true} label={t12} value={t13} onChange={t14} placeholder={t15} size="sm" required={true} />;
    $[26] = formState.subcategoryName;
    $[27] = t12;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = icon => updateFormState({
      selectedIcon: icon
    });
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== formState.selectedIcon || $[32] !== titleSlug) {
    t18 = <MapIconSelector selectedIcon={formState.selectedIcon} onIconChange={t17} fontId={titleSlug} />;
    $[31] = formState.selectedIcon;
    $[32] = titleSlug;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== categoryOptions || $[35] !== forcedCategoryId || $[36] !== formState.selectedCategory || $[37] !== mapCategories || $[38] !== t) {
    t19 = <FlexColumn gap="4">{forcedCategoryId ? <Button color="secondary" size="sm" fullWidth={true} disabled={true}>{mapCategories?.find(cat => cat.externalId === forcedCategoryId)?.title}</Button> : <Select label={t(_temp9)} value={formState.selectedCategory} onValueChange={value => updateFormState({
        selectedCategory: value
      })} placeholder={t(_temp10)} size="sm" fullWidth={true} aria-label={t(_temp11)} trigger={<Button color="secondary" size="sm">{formState.selectedCategory ? mapCategories?.find(cat_0 => cat_0.externalId === formState.selectedCategory)?.title : t(_temp12)}</Button>}>{categoryOptions}</Select>}</FlexColumn>;
    $[34] = categoryOptions;
    $[35] = forcedCategoryId;
    $[36] = formState.selectedCategory;
    $[37] = mapCategories;
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t18 || $[41] !== t19) {
    t20 = <FlexRow gap="12" align="center" width="full" wrap="wrap">{t18}{t19}</FlexRow>;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t) {
    t21 = t(_temp13);
    $[43] = t;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_1 => updateFormState({
      description: e_1.target.value
    });
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  const t23 = `${formState.description.length}/500`;
  let t24;
  if ($[46] !== formState.description || $[47] !== t21 || $[48] !== t23) {
    t24 = <TextArea fullWidth={true} size="sm" label={t21} value={formState.description} onChange={t22} placeholder="Max 500 characters" maxLength={500} helperText={t23} />;
    $[46] = formState.description;
    $[47] = t21;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = details => updateFormState({
      excludeFromChecklists: !!details.checked
    });
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== formState.excludeFromChecklists) {
    t26 = <Checkbox id="exclude-subcategory-from-checklists" label="Exclude subcategory from checklists" checked={formState.excludeFromChecklists} onCheckedChange={t25} size="sm" />;
    $[51] = formState.excludeFromChecklists;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t11 || $[54] !== t16 || $[55] !== t20 || $[56] !== t24 || $[57] !== t26) {
    t27 = <Fieldset legend={t11} legendHidden={true} spacing="md">{t16}{t20}{t24}{t26}</Fieldset>;
    $[53] = t11;
    $[54] = t16;
    $[55] = t20;
    $[56] = t24;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t) {
    t28 = t(_temp14);
    $[59] = t;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== t28) {
    t29 = <Button variant="ghost" onClick={handleCancel} color="secondary" size="sm">{t28}</Button>;
    $[61] = t28;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  const t30 = !isFormValid || isLoading;
  let t31;
  if ($[63] !== isLoading || $[64] !== t) {
    t31 = isLoading ? t(_temp15) : t(_temp16);
    $[63] = isLoading;
    $[64] = t;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t30 || $[67] !== t31) {
    t32 = <Button type="submit" color="success" size="sm" disabled={t30}>{t31}</Button>;
    $[66] = t30;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== t29 || $[70] !== t32) {
    t33 = <FlexRow gap="4" justify="end">{t29}{t32}</FlexRow>;
    $[69] = t29;
    $[70] = t32;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== t10 || $[73] !== t27 || $[74] !== t33) {
    t34 = <Form spacing="md" onSubmit={t10}>{t27}{t33}</Form>;
    $[72] = t10;
    $[73] = t27;
    $[74] = t33;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  return t34;
};
function _temp($_1) {
  return $_1.add_subcategory;
}
function _temp2($_2) {
  return $_2.subcategory_added_successfully;
}
function _temp3($) {
  return $.add_subcategory;
}
function _temp4($_0) {
  return $_0.failed_to_create_subcategory;
}
function _temp5(category) {
  return <SelectItem key={category.externalId} item={{
    label: category.title,
    value: category.externalId
  }}>{category.title}</SelectItem>;
}
function _temp6($_3) {
  return $_3.subcategory_details;
}
function _temp7($_4) {
  return $_4.name;
}
function _temp8($_5) {
  return $_5.subcategory_name;
}
function _temp9($_6) {
  return $_6.category;
}
function _temp10($_7) {
  return $_7.select_category;
}
function _temp11($_8) {
  return $_8.select_parent_category;
}
function _temp12($_9) {
  return $_9.select_category;
}
function _temp13($_10) {
  return $_10.description;
}
function _temp14($_11) {
  return $_11.clear;
}
function _temp15($_12) {
  return $_12.adding;
}
function _temp16($_13) {
  return $_13.add_subcategory;
}